import { FileCheck2Icon, FolderOpenIcon, ImagesIcon, NotebookTabsIcon } from 'lucide-react';

export const bonuses = [
  [
    '01',
    'Banco de 300 Exámenes Multiformato',
    '50 preguntas de opción múltiple nivel básico, 50 intermedio, 50 avanzado, 50 verdadero/falso, 30 ejercicios de completar, 20 asociaciones, 30 casos clínicos de examen y 20 preguntas de desarrollo corto. Organizadas por tomo, unidad y nivel, con clave de respuestas completa.',
    '$18.000 ARS',
    FileCheck2Icon,
  ],
  [
    '02',
    '150 Casos Clínicos Resueltos Nivel Experto',
    'Desde casos básicos de bioseguridad y asepsia hasta urgencias intraoperatorias y dilemas éticos. Ambientados en quirófanos argentinos reales, con preguntas guía, resolución completa, fundamento técnico y nota docente. Los 9 casos integradores incluyen análisis de causa raíz.',
    '$15.000 ARS',
    FolderOpenIcon,
  ],
  [
    '03',
    'Kit Docente Editable Completo',
    '12 formularios oficiales editables (conteo quirúrgico, Checklist OMS versión argentina, trazabilidad de implante, reporte de evento adverso), 8 plantillas de planificación, 6 fichas de seguimiento, 15 carteles para el laboratorio, 8 guías de práctica y 20 actividades listas para imprimir.',
    '$15.000 ARS',
    NotebookTabsIcon,
  ],
  [
    '04',
    'Banco de Fichas Técnicas e Imágenes Descriptivas',
    '200 fichas técnicas del instrumental con descripción visual, características identificatorias, función, confusión frecuente y dato docente. 4 guías de identificación visual, 50 tarjetas flash, 15 tablas de referencia rápida y 8 esquemas de mesas quirúrgicas.',
    '$20.000 ARS',
    ImagesIcon,
  ],
] as const;
